import React from 'react';
import styles from './OverviewHeader.module.sass';
import Title from 'Components/Atoms/Title/Title';
import EntityIcon from 'Components/Atoms/EntityIcon/EntityIcon';

const OverviewHeader = ({icon, title, children}: Props) => {

    return <div className={styles['overviewheader']}>
        <div className={styles['overviewheader__icon']}>
            <EntityIcon
                entity={icon}
                size='xlarge'
            />
        </div>
        <div className={styles['overviewheader__info']}>
            <Title
                size='large'
                weight='bold'
            >
                { title }
            </Title>
            <div className={styles['overviewheader__info-content']}>
                { children }
            </div>
        </div>
    </div>
}

interface Props {
    icon: React.ComponentProps<typeof EntityIcon>['entity']
    title: any
    children: any
}

export default OverviewHeader;